/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingEntitlementStatus =
    (typeof BuildingEntitlementStatus)[keyof typeof BuildingEntitlementStatus];

export const BuildingEntitlementStatus = {
    PendingPayment: 1,
    Active: 2,
    PastDue: 3,
    Cancelled: 4,
} as const;
